import { render, staticRenderFns } from "./RateLabel.vue?vue&type=template&id=3f31e28c"
import script from "./RateLabel.vue?vue&type=script&lang=js"
export * from "./RateLabel.vue?vue&type=script&lang=js"
import style0 from "./RateLabel.vue?vue&type=style&index=0&id=3f31e28c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports